export function RunProblemNotice({ status, code, message, sent, discarded }: {
  status: string; code?: string | null; message: string; sent: number; discarded: number;
}) {
  if (!["BLOCKED", "FAILED", "ACTION_REQUIRED", "DEGRADED"].includes(status)) return null;
  return <section className="warning-banner" role="alert" aria-label="Problema de la ejecución">
    <div>
      <strong>{sent === 0 ? "La ejecución se detuvo sin enviar correos" : "La ejecución requiere atención"}</strong>
      <p>{message}</p>
      <p>{sent} correos enviados · {discarded} contactos descartados. No hay confirmación de éxito.</p>
      {code && <small>Código: {code}</small>}
    </div>
  </section>;
}
